import { Component, computed, inject } from '@angular/core';
import { Bootstrap } from '@synegen/utility';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-context-header',
  standalone: true,
  imports: [],
  templateUrl: './context-header.html',
  styleUrls: ['./context-header.scss']
})
export class ContextHeader {
  #http: HttpClient = inject(HttpClient);
  #bootstrap: Bootstrap = inject(Bootstrap);
  #router: Router = inject(Router);

  readonly contextBannerText = computed<string | null>(() => {
    const impersonatingUser = this.#bootstrap.get('impersonatingUser');
    if (impersonatingUser) {
      return 'This can\'t happen yet';
    }

    const isStepped = this.#bootstrap.get('steppedTenant');
    if (isStepped) {
      const tenant = this.#bootstrap.get<{ displayName: string; tenantKey: string }>('tenant');
      if (!tenant) {
        return null;
      }
      return `You are viewing a tenant that is not your own: ${tenant.displayName} (${tenant.tenantKey})`;
    }

    return null;
  });


  popContext = () => {
    this.#http.post('tenant/step-out', {}).subscribe({
      next: () => {
        this.#bootstrap.load().subscribe(() => {
          this.#router.navigateByUrl('/').then(()=>location.reload());
        });
      },
      error: (errorResponse: HttpErrorResponse) => {
        console.error(errorResponse.error);
      }
    });
  };
}
